<template>
  <baseMcInbound></baseMcInbound>
</template>
<script>
  import baseMcInbound from './baseMcInbound.vue';

  export default {
    components: {
      baseMcInbound,
    },
    name: 'mcInboundAdd',
  };
</script>
